import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { animationPop } from './animationPop';
import { Count } from './Count';

const getColor = (theme, color) => {
  if (color === 'primary') return theme.mainColor;
  if (color === 'success') return theme.colors.positive;
  return theme.secondaryColor;
};

const doneStyles = css`
  color: ${({ theme, color }) => (color ? getColor(theme, color) : theme.colors.font)};

  svg {
    fill: ${({ theme, color, fill }) => fill || (color ? getColor(theme, color) : theme.colors.font)};
    stroke: ${({ theme, color }) => (color ? getColor(theme, color) : theme.colors.font)};
    ${animationPop};
  }
`;

const disabledStyles = css`
  cursor: not-allowed;

  &:hover {
    color: ${({ theme }) => theme.colors.fontLL};
  }
`;

const highlightedStyles = css`
  &,
  a {
    color: ${({ theme }) => theme.colors.secondaryD};
  }

  &:hover {
    &,
    a {
      color: ${({ theme }) => theme.colors.secondaryDD};
    }
  }
`;

/* eslint-disable */
export const Action = styled.div`
  display: flex;
  align-items: center;
  margin: 6px 24px 6px 0;
  cursor: pointer;
  ${getFont(-1, 'compact')};
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.fontLL};
  transition: color 0.15s ease;

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }

  span {
    margin-left: 5px;
  }

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    color: ${({ theme, color }) => (color ? getColor(theme, color) : theme.colors.font)};

    ${/* sc-sel */ Count} {
      ${({ theme, color, solved }) =>
        solved ? `background-color: ${color ? getColor(theme, color) : theme.colors.font}` : null};
    }
  }

  ${maxMediaQueries.phone`
    margin-right: 18px;

    span {
      display: none;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  `};

  ${({ done }) => done && doneStyles};
  ${({ disabled }) => disabled && disabledStyles};
  ${({ highlighted }) => highlighted && highlightedStyles};
`;
/* eslint-enable */
